import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { resolvePageTransitionKey } from "../../../design-system/tokens/pageTransitionMotion";
import { PageTransition } from "./PageTransition";
import type { PageTransitionOutletProps } from "./PageTransition.types";
import { PageSkeleton } from "./PageSuspense";

export const PageTransitionOutlet: React.FC<PageTransitionOutletProps> = ({
  scope = "full",
  fallback,
}) => {
  const location = useLocation();
  const transitionKey = resolvePageTransitionKey(location.pathname, scope);

  return (
    <PageTransition transitionKey={transitionKey}>
      <React.Suspense fallback={fallback ?? <PageSkeleton />}>
        <Outlet />
      </React.Suspense>
    </PageTransition>
  );
};
